export const ComponentResources = {
    es: {
        ['signature']: 'Firma',
        ['checkin']: 'Retención',
        ['payment']: 'Pago',
        ['help']: 'Ayuda',
        ['reset']: 'Reiniciar',
        ['are_you_there']: '¿Sigues ahí?',
        ['session_will_expire_in']: 'Tu sesión expirará por inactividad en',
        ['btn_im_here']: '¡Sí, sigo aquí!',
    },
    en: {
        ['signature']: 'Signature',
        ['checkin']: 'Check-in',
        ['payment']: 'Payment',
        ['help']: 'Help',
        ['reset']: 'Reset',
        ['are_you_there']: 'Are you still there?',
        ['session_will_expire_in']: 'Your session will expire due to inactivity in',
        ['btn_im_here']: "Yes, I'm still here!",
    }
}
